import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { findListingByLstId } from "@/lib/utils";
import { NotFound } from "./notfound";
import { WithErrorAndLoading } from "@/components/with-error-and-loading";
import { useListings } from "@/hooks/use-listings";
import { CircleDashed } from "lucide-react";
import { AssetLink } from "@/components/links";

export function Asset() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { isPending: loading, error: error, data: listings } = useListings();
  const {
    isPending: sunsetLoading,
    error: sunsetError,
    data: sunsetListings,
  } = useListings(undefined, true);
  const [found, setFound] = useState(false);
  const [mfToken, setMfToken] = useState(false);

  useEffect(() => {
    if (found) return;
    if (id === "3000000000") {
      setMfToken(true);
    } else if (id && (listings?.size || sunsetListings?.size)) {
      if (listings?.size) {
        const found = findListingByLstId(listings, BigInt(id));
        if (found) {
          navigate(`/dualSTAKE/${found.lstName}`);
          setFound(true);
          return;
        }
      } 
      if (id && sunsetListings?.size) {
        const found2 = findListingByLstId(sunsetListings, BigInt(id));
        if (found2) {
          navigate(`/dualSTAKE/${found2.lstName}`);
          setFound(true);
        }
      }
    }
  }, [id, found, listings, sunsetListings]);

  if (mfToken) {
    return (
      <>
        <div className="relative">
          <CircleDashed className="animate-pulse" size={64} />
          <div className="absolute animate-pulse inset-0 flex justify-center items-center text-xs">
            $MF
          </div>
        </div>
        <div className="text-lg my-2">Myth Finance Token Placeholder</div>
        <div className="flex flex-col items-start mx-1">
          <div>if we decide to release a token,</div>
          <div>
            it will be this asset ID: <AssetLink id={3000000000} />
          </div>
        </div>
      </>
    );
  }

  return (
    <WithErrorAndLoading
      loading={loading || sunsetLoading || found}
      error={error?.message ?? sunsetError?.message}
    >
      <NotFound />
    </WithErrorAndLoading>
  );
}
